import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./TvArtistSlider.scss";

// import Swiper core and required modules
import SwiperCore, { Navigation } from "swiper";
import TvArtistDesc from "./TvArtistDesc";
import { img_300, unavailable } from "../../config/config";

// install Swiper modules
SwiperCore.use([Navigation]);

const TvArtistSlider = ({ cast }) => {
  return (
    <>
      <Swiper
        breakpoints={{
          // when window width is >= 340px
          320: {
            // width: 320,
            slidesPerView: 2,
            // spaceBetween: 5,
          },
          // when window width is >= 640px
          640: {
            // width: 640,
            slidesPerView: 3,
            // spaceBetween: 30,
          },
          1024: {
            // width: 1024,
            slidesPerView: 4,
          },
        }}
        slidesPerView={4}
        spaceBetween={30}
        navigation={true}
        className="mySwiper"
        style={{ position: "unset" }}
      >
        {React.Children.toArray(
          cast?.map((it) => {
            return (
              <SwiperSlide>
                <img
                  className="tv-artist"
                  src={
                    it?.profile_path
                      ? `${img_300}/${it?.profile_path}`
                      : unavailable
                  }
                  alt="TV poster"
                />
                <TvArtistDesc artistName={it.name} />
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </>
  );
};

export default TvArtistSlider;
